module.exports = __webpack_public_path__ + "fonts/Poppins-Medium.7e588a2.woff";